import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'propertyGetFields',
})

export class PropertyGetFieldsPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): any {
    return properties.getField(controlName);
  }
}
